import { useMutation, useQueryClient } from '@tanstack/react-query';
import { attachProductsToGroup } from '../services/security-groups';

export function useAttachProductsMutation(groupId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (productIds: string[]) => attachProductsToGroup(groupId, productIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['security-group', groupId, 'products'] });
      queryClient.invalidateQueries({ queryKey: ['security-group', groupId] });
      queryClient.invalidateQueries({ queryKey: ['security-groups'] });
    },
  });
}
